/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { UserProfileService } from './services/user-profile.service';
import { IdealCustomerProfileService } from './services/ideal-customer-profile.service';
import { ExportService } from './services/export.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    UserProfileService,
    IdealCustomerProfileService,
    ExportService,
    ApiConfiguration
  ],
})
export class UserProfileApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<UserProfileApiModule> {
    return {
      ngModule: UserProfileApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: UserProfileApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('UserProfileApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
